import CommonSidePortal from 'Common/SidePortal/SidePortal';
import { DAM_SVG } from 'components/Dam/DamAssets';
import WordWrapEllipse from 'components/Dam/WordWrapEllipse';
import React, { Fragment, useRef, useState } from 'react';
import { Table } from 'reactstrap';
import CommonThreeDotSvg from '../CommonThreeDotSvg';
import {
  DELETE_ASSETS_FOR_EVER,
  DELETE_MULTIPLE_ASSET,
  EditAssetDetailsURL,
  Editfolder,
  UPDATE_FOLDER_COLOR,
} from 'components/Dam/DAM_API/urls';
import Axios from 'functions/Axios';
import { useDispatch } from 'react-redux';
import { SelectedAssetData, setOpenPopup, SetSelctedFoldersData } from 'actions/damActions';
import { useSelector } from 'react-redux';
import MoveToAssetDesign from './MoveToAssetDesign';
import { Deletemodel } from 'Common/Deletemodel';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import InputC from 'Common/Inputs/index.tsx';
import { ButtonC } from 'Common/Buttons';
import ShareAssetSection from './ShareAsset';
import { selectRangeByUUID } from 'components/Dam/Assets/assitdata';
import moment from 'moment';
import { useDownloadAssets } from 'context/DownloadAssetsContext';
import { MODULE_IDS, useHasAccess, USER_RIGHTS } from 'actions/userActions';
import { DAM_API_URL } from 'Constant';
import AddToCollectionCommonModal from './AddToCollection';
import addcomponent from '../../../../assets/V2-images/addcomponent.svg';

function CopyField({ label, value }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{ fontSize: '12px', marginBottom: '4px', color: '#6B7280' }}>{label}</div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <input
          type="text"
          value={value || ''}
          readOnly
          style={{
            flex: 1,
            padding: '6px 8px',
            fontSize: '12px',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
          }}
        />

        <button
          onClick={handleCopy}
          style={{
            padding: '6px 10px',
            fontSize: '12px',
            borderRadius: '6px',
            border: '1px solid #E5E7EB',
            background: '#F9FAFB',
            cursor: 'pointer',
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}

const Headers = ['Name', 'Type', 'Format', 'Size', 'Uploaded On'];

const Data = [
  {
    Name: 'Logo.png',
    Type: 'Image',
    Format: 'PNG',
    Size: '2MB',
    'Uploaded On': '2025-10-10',
    isSelected: true,
  },
  {
    Name: 'Video.mp4',
    Type: 'Video',
    Format: 'MP4',
    Size: '12MB',
    'Uploaded On': '2025-10-12',
  },
];

const HeadersData = [
  { id: 1, title: 'Name', data: 'assetName' },
  { id: 2, title: 'Owner', data: 'createdBy' },
  { id: 2, title: 'Last Modified', data: 'updatedAt', isMoment: true },
  { id: 5, title: 'Created On', data: 'createdOn', isMoment: true },
  { id: 4, title: 'Size', data: 'assetSize' },
];

const selectionColors = [
  {
    id: 1,
    label: 'color1',
    hex: '#929292',
    hsl: 'hsla(0, 0%, 57%, 1)',
  },
  {
    id: 2,
    label: 'color2',
    hex: '#B995E5',
    hsl: 'hsla(0, 0%, 57%, 1)',
  },
  {
    id: 3,
    label: 'color3',
    hex: '#E595DD',
    hsl: 'hsla(306, 61%, 74%, 1)',
  },
  {
    id: 4,
    label: 'color4',
    hex: '#E59596',
    hsl: 'hsla(359, 61%, 74%, 1)',
  },
  {
    id: 5,
    label: 'color5',
    hex: '#E5C095',
    hsl: 'hsla(32, 61%, 74%, 1)',
  },
  {
    id: 6,
    label: 'color6',
    hex: '#E5E295',
    hsl: 'hsla(58, 61%, 74%, 1)',
  },
  {
    id: 7,
    label: 'color7',
    hex: '#B8E595',
    hsl: 'hsla(94, 61%, 74%, 1)',
  },
  {
    id: 8,
    label: 'color8',
    hex: '#95E5AD',
    hsl: 'hsla(138, 61%, 74%, 1)',
  },
  {
    id: 9,
    label: 'color9',
    hex: '#95D4E5',
    hsl: 'hsla(193, 61%, 74%, 1)',
  },
  {
    id: 10,
    label: 'color10',
    hex: '#95A2E5',
    hsl: 'hsla(230, 61%, 74%, 1)',
  },
  {
    id: 11,
    label: 'color11',
    hex: '#993E17',
    hsl: 'hsla(18, 74%, 35%, 1)',
  },
  {
    id: 12,
    label: 'color12',
    hex: '#179926',
    hsl: 'hsla(127, 74%, 35%, 1)',
  },
  {
    id: 13,
    label: 'color13',
    hex: '#177299',
    hsl: 'hsla(198, 74%, 35%, 1)',
  },
  {
    id: 14,
    label: 'color14',
    hex: '#201799',
    hsl: 'hsla(244, 74%, 35%, 1)',
  },
  {
    id: 15,
    label: 'color15',
    hex: '#99175A',
    hsl: 'hsla(329, 74%, 35%, 1)',
  },
];
const CommonTable = ({
  headers = Headers,
  data = Data,
  files,
  setAssets,
  HandleDelete,
  fromBrandAssets,
  setselectedfolderId,
  trash,
}) => {
  const { startDownload } = useDownloadAssets();
  const [activeId, setActiveId] = useState();
  const [movetoModal, setMovetoModal] = useState(false);
  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [deletemodal, setdeletemodal] = useState(false);
  const [passname, setpassname] = useState('');
  const [textvalue, settextvalue] = useState();
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const [responsedLink, setResponsedLink] = useState();
  const [error, setError] = useState({});
  const [expiredate, setexpiredate] = useState();
  const [expitetime, setexpitetime] = useState();
  const [assetInfo, setAssetInfo] = useState({});
  const [emails, setEmails] = useState([]);
  const [Authenticated, setAuthenticated] = useState(false);
  const [isExpiration, setIsExpiration] = useState(false);
  const [indexdata, setindexdata] = useState();
  const [sharelink, setsharelink] = useState(false);
  const [showbar, setshowbar] = useState(false);
  const [allassetsData, setAllAssetsData] = useState(data);
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [renameDetails, setRenameDetails] = useState({
    isFolder: false,
    Data: '',
  });
  const [openRightSection, setOpenRightSection] = useState(false);
  const [openEmmbedPopup, setOpenEmmbedPopup] = useState(null);
  const [openCollectionModal, setOpenCollectionModal] = useState(false);

  const hasDAMAccess = useHasAccess();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedAssets, selectedFolders } = useSelector((state) => state.dam);
  const lastKeyPressTime = useRef(0);
  const lastKey = useRef(null);

  const closeBtn1 = (
    <div onClick={() => setAddToCollectionModal(false)}> {DAM_SVG.closeSvgIcon}</div>
  );

  const deletmodal = (folderName) => {
    setdeletemodal(true);
    setpassname(folderName);
  };

  const handledownload = async (data) => {
    try {
      var _data = {
        fileId: data?.assetId ? [data?.assetId] : [],
        folderId: data?.id ? [data?.id] : [],
      };
      startDownload(_data);
      setActiveId();
    } catch (err) {
      console.error(err);
    }
  };

  const handleshowdata = async (damFileId, index) => {
    setResponsedLink();
    setError({});
    setexpiredate();
    setexpitetime();
    setAssetInfo({});
    setEmails([]);
    setAuthenticated(true);
    setIsExpiration(false);
    setindexdata(index);
    setsharelink(!sharelink);
    setshowbar(false);
    setActiveId();
  };

  const handleDelete = async () => {
    try {
      setTimeout(() => {
        setdeletemodal(!deletemodal);
      }, 2000);
      const result = await Axios.post(trash ? DELETE_ASSETS_FOR_EVER : DELETE_MULTIPLE_ASSET, {
        fileId: data
          ?.filter((item) => item?.typeIdentification === 2 && item?.isSelected)
          ?.map((item) => item?.assetId),
        folderId: data
          ?.filter((item) => item?.typeIdentification === 1 && item?.isSelected)
          ?.map((item) => item?.id),
      });
      setdeletemodal(false);

      HandleDelete();
    } catch (err) {
      toast.error(err.message);
      console.error(err);
    }
  };

  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };
  // Handle mouse clicks with modifier keys
  const handleMouseClick = (e, data) => {
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
      // HandleSelect({
      //   Image: Data,
      //   Key: 1,
      // });
      setPrevIndexSelected(data?.identifierId);

      if (data?.typeIdentification === 1) {
        const dispatchableSelectedFolders = selectedFolders?.map((item) =>
          item?.id === data?.id
            ? { ...item, isSelected: !item?.isSelected }
            : { ...item, isSelected: false },
        );
        const resetFolders = selectedAssets?.map((item) => ({
          ...item,
          isSelected: false,
        }));
        dispatch(SelectedAssetData(resetFolders));

        dispatch(SetSelctedFoldersData(dispatchableSelectedFolders));
        if (setselectedfolderId) {
          setselectedfolderId((pre) => [...pre, data?.id]);
        }
      } else {
        const dispatchableSelectedFolders = selectedAssets?.map((item) =>
          item?.assetId === data?.assetId
            ? { ...item, isSelected: !item?.isSelected }
            : { ...item, isSelected: false },
        );
        const resetFolders = selectedFolders?.map((item) => ({
          ...item,
          isSelected: false,
        }));
        dispatch(SetSelctedFoldersData(resetFolders));

        dispatch(SelectedAssetData(dispatchableSelectedFolders));
      }
    }
    if (e.shiftKey && e.button === 0) {
      // HandleSelect({
      //   Image: Data,
      //   Key: 3,
      // });

      const returnedValueData = selectRangeByUUID(
        [
          ...(selectedFolders || [])?.map((item) => ({
            ...item,
            typeIdentification: 1,
            assetName: item?.folderName,
            identifierId: item?.id,
          })),
          ...(selectedAssets || [])?.map((item) => ({
            ...item,
            typeIdentification: 2,
            identifierId: item?.assetId,
          })),
        ],
        prevIndexSelected,
        data?.identifierId,
        'identifierId',
      );
      const dispatchableFolder = returnedValueData?.filter(
        (item) => item?.typeIdentification === 1,
      );
      const dispatchableAssets = returnedValueData?.filter(
        (item) => item?.typeIdentification === 2,
      );

      dispatch(SetSelctedFoldersData(dispatchableFolder));
      dispatch(SelectedAssetData(dispatchableAssets));
      // dispatch(SelectedAssetData(returnedValueData));
    }
    // dispatch(SetSelctedFoldersData(dispatchableFolder));
    // dispatch(SelectedAssetData(dispatchableAssets));
    if (e.ctrlKey && !e.shiftKey) {
      if (data?.typeIdentification === 1) {
        setPrevIndexSelected(data?.identifierId);

        const dispatchableSelectedFolders = selectedFolders?.map((item) =>
          item?.id === data?.id ? { ...item, isSelected: !item?.isSelected } : { ...item },
        );
        // const resetFolders = selectedAssets?.map((item) => ({
        //   ...item,
        //   isSelected: false,
        // }));
        // dispatch(SelectedAssetData(resetFolders));

        dispatch(SetSelctedFoldersData(dispatchableSelectedFolders));
      } else {
        const dispatchableSelectedFolders = selectedAssets?.map((item) =>
          item?.assetId === data?.assetId
            ? { ...item, isSelected: !item?.isSelected }
            : { ...item },
        );
        // const resetFolders = selectedFolders?.map((item) => ({
        //   ...item,
        //   isSelected: false,
        // }));
        // dispatch(SetSelctedFoldersData(resetFolders));

        dispatch(SelectedAssetData(dispatchableSelectedFolders));
      }
    }

    if (e.altKey) {
    }
  };

  // Handle double mouse clicks
  const handleDoubleClick = (e, data) => {
    if (fromBrandAssets || trash) {
      return;
    }
    // HandleSelect(Data);
    if (data.typeIdentification === 2) {
      navigate('/dam/dam-asset-information_v2', { state: { props: data?.assetId } });
    } else {
      navigate(`${data?.id}`);
    }
    // navigate('/dam/dam-asset-information_v2', { state: { props: Data?.damFileId } });

    if (e.shiftKey) {
    }
  };

  // Handle keyboard keys like Shift + Enter + detect double presses
  const handleKeyDown = (e) => {
    const now = Date.now();

    if (e.shiftKey && e.key === 'Enter') {
    }

    if (e.ctrlKey && e.key === 'Enter') {
    }

    if (e.altKey && e.key === 'Enter') {
    }

    // Detect double key press (same key within 400ms)
    if (lastKey.current === e.key && now - lastKeyPressTime.current < 400) {
    }

    lastKey.current = e.key;
    lastKeyPressTime.current = now;
  };

  const renameHandler = async () => {
    try {
      const formData = new FormData();
      if (renameDetails?.Data?.assetId) {
        formData.append('damFileId', renameDetails?.Data?.assetId);
      }
      formData.append(renameDetails?.Data?.id ? 'newFolderName' : 'assetName', textvalue);
      renameDetails?.isFolder && formData.append('folderId', renameDetails?.Data?.id);
      let response;
      if (renameDetails?.Data?.assetId) {
        response = await Axios.post(EditAssetDetailsURL, formData);
      } else {
        response = await Axios.post(Editfolder, formData);
      }
      if (response?.data?.success) {
        toggleAddToCollection();
        toast.success(response?.data?.message);
        HandleDelete();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSaveColor = async (Data, selectedColor) => {
    try {
      const result = await Axios.put(UPDATE_FOLDER_COLOR, {
        color: selectedColor?.hex,
        folderId: Data?.id,
      });
      toast.success(result?.data?.message);
      setActiveId(null);
      HandleDelete();
      // HandleDelete();
      setOpenRightSection(false);
      // getData(false);
      // setSelectedColor();
    } catch (err) {
      console.error(err);
    }
  };

  async function handleRestoreAsset(id) {
    await Axios.post(`${DAM_API_URL}/apidam/restore-delete-asset`, {
      fileId: data
        ?.filter((item) => item?.typeIdentification === 2 && item?.isSelected)
        ?.map((item) => item?.assetId),
      folderId: data
        ?.filter((item) => item?.typeIdentification === 1 && item?.isSelected)
        ?.map((item) => item?.id),
    });
    HandleDelete();
    setActiveId(null);
  }
  return (
    <Fragment>
      {movetoModal && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          HandleAssetMove={() => {
            HandleDelete();
          }}
          Data={selectedDamFieldId}
        />
      )}

      {deletemodal && (
        <Deletemodel
          deletemodal={deletemodal}
          toggledelete={() => {
            setdeletemodal(!deletemodal);
          }}
          handleDelete={handleDelete}
          loading={false}
          Header={`${trash ? 'Delete permanently' : 'Move to trash'}`}
          Content={`${trash ? `Are you sure you want to Delete?` : `Asset will be deleted after 30 days?`}`}
        />
      )}

      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={[
            ...(Array.isArray(selectedAssets)
              ? selectedAssets.filter((item) => item?.isSelected).map((item) => item.assetId)
              : []),
            ...(Array.isArray(selectedFolders)
              ? selectedFolders.filter((item) => item?.isSelected).map((item) => item.id)
              : []),
          ]}
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
        />
      )}
      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename File
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => {
              settextvalue(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            color="Secondary"
            size="lg"
            click={() => setAddToCollectionModal(false)}
          />
          <ButtonC text="Save" size="lg" click={renameHandler} />
        </ModalFooter>
      </Modal>
      <Table responsive className="dam-table draftAssets-table product-table">
        {' '}
        <thead>
          <tr>
            {HeadersData.map((header, index) => (
              <th key={index}>{header?.title}</th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {[...(selectedFolders || []), ...(selectedAssets || [])].length > 0 ? (
            [
              ...(selectedFolders || [])?.map((item) => ({
                ...item,
                typeIdentification: 1,
                assetName: item?.folderName,
                identifierId: item?.id,
              })),
              ...(selectedAssets || [])?.map((item) => ({
                ...item,
                typeIdentification: 2,
                identifierId: item?.assetId,
              })),
            ].map((row, rowIndex) => {
              const isSelf = hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])
                ? true
                : row.isSelf;
              console.log(isSelf, 'isSelf');

              return (
                <tr
                  key={rowIndex}
                  className={row?.isSelected && 'dam_selected_design'}
                  onClick={(e) => handleMouseClick(e, row)} // Mouse click
                  onDoubleClick={(e) => handleDoubleClick(e, row)} // Mouse double click
                  onKeyDown={handleKeyDown} // Keyboard + double key detection
                >
                  {HeadersData.map((header, colIndex) => (
                    <td key={colIndex}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                        }}
                        className="dam-no-select"
                      >
                        {header?.id === 1 && (
                          <>
                            {row?.typeIdentification === 1 ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <mask
                                  id="mask0_7795_12750"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                >
                                  <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_7795_12750)">
                                  <path
                                    d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H9.175C9.44167 4 9.69583 4.05 9.9375 4.15C10.1792 4.25 10.3917 4.39167 10.575 4.575L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                                    fill={row?.color ?? '#757575'}
                                    {...(row?.color === '#FFFFFF'
                                      ? {
                                          stroke: '#757575', // border color
                                          strokeWidth: 0.2, // adjust thickness
                                        }
                                      : {})}
                                  />
                                </g>
                              </svg>
                            ) : (
                              DAM_SVG.imagePreviewIcons
                            )}
                          </>
                        )}{' '}
                        <WordWrapEllipse
                          Text={
                            header?.isMoment
                              ? moment(row[header?.data]).format('YYYY-MM-DD HH:mm:ss')
                              : row[header?.data]
                          }
                        />{' '}
                      </div>
                    </td>
                  ))}

                  <td>
                    {row?.typeIdentification === 1 ? (
                      <CommonSidePortal
                        activeId={activeId}
                        setActiveId={setActiveId}
                        portalId={rowIndex}
                        ViewSection={<CommonThreeDotSvg />}
                        OpenSection={
                          trash ? (
                            <>
                              {' '}
                              {isSelf && hasDAMAccess(MODULE_IDS.DAM ,  [USER_RIGHTS.FullAccess]) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();

                                    setSelectedDamFieldId(row.id);

                                    deletmodal(row?.folderName);
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.redDeleteIconSvgComponent}
                                  <p className="list_cart">{trash ? 'Delete' : 'Move to trash'}</p>
                                </div>
                              )}
                              {isSelf && hasDAMAccess(MODULE_IDS.DAM ,  [USER_RIGHTS.FullAccess]) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={() => {
                                    // setSelectedDamFieldId(image.damFileId);
                                    handleRestoreAsset(row.id);
                                    setSelectedDamFieldId(row.id);
                                  }}
                                >
                                  {/* <img src={deleteicon} alt="deleteicon" /> */}

                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-archive-restore-icon lucide-archive-restore"
                                  >
                                    <rect width="20" height="5" x="2" y="3" rx="1" />
                                    <path d="M4 8v11a2 2 0 0 0 2 2h2" />
                                    <path d="M20 8v11a2 2 0 0 1-2 2h-2" />
                                    <path d="m9 15 3-3 3 3" />
                                    <path d="M12 12v9" />
                                  </svg>
                                  <p className="list_cart">Restore</p>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="">
                              {hasDAMAccess(MODULE_IDS.DAM ,  [USER_RIGHTS.FullAccess]) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={() => {
                                    setMovetoModal(true);
                                    setSelectedDamFieldId(row.id);
                                    setActiveId();
                                  }}
                                >
                                  {DAM_SVG.moveAssetSvgIcon}
                                  <p className="list_cart">Move Folder</p>
                                </div>
                              )}
                              {isSelf && hasDAMAccess(MODULE_IDS.DAM ,  [USER_RIGHTS.FullAccess]) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();

                                    setSelectedDamFieldId(row.id);

                                    deletmodal(row?.folderName);
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.redDeleteIconSvgComponent}
                                  <p className="list_cart">{trash ? 'Delete' : 'Move to trash'}</p>
                                </div>
                              )}
                              {hasDAMAccess(MODULE_IDS.DAM) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();

                                    handledownload(row);
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.downloadIcons}
                                  <p className="list_cart">Download</p>
                                </div>
                              )}
                              {hasDAMAccess(MODULE_IDS.DAM) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();
                                    setSelectedDamFieldId(row?.id);
                                    setRenameDetails({
                                      isFolder: true,
                                      Data: row,
                                    });

                                    settextvalue(row?.folderName);
                                    setAddToCollectionModal(!AddToCollectionModal);
                                  }}
                                >
                                  {DAM_SVG.blackrenameIcon}
                                  <p className="list_cart">Rename</p>
                                </div>
                              )}
                              {hasDAMAccess(MODULE_IDS.DAM) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(setOpenPopup(row));
                                    setActiveId();
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.blackShareIconSvg}
                                  <p className="list_cart">Share</p>
                                </div>
                              )}
                              {hasDAMAccess(MODULE_IDS.DAM , [USER_RIGHTS.FullAccess]) && (
                                <div
                                  className="p-relative"
                                  style={{
                                    position: 'relative',
                                  }}
                                >
                                  <div
                                    className="d-flex justify-content-between align-items-center gap-2 pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenRightSection(!openRightSection);
                                    }}
                                  >
                                    <div className="d-flex gap-2 align-items-center">
                                      {DAM_SVG.labelByColorSvgIcon}
                                      <p className="list_cart">Label By Color</p>
                                    </div>
                                    <div
                                      style={{
                                        paddingRight: '16px',
                                      }}
                                      onClick={(e) => {
                                        // e.stopPropagation();
                                        // setOpenRightSection(!openRightSection);
                                      }}
                                    >
                                      {DAM_SVG.rightSideSvgIcon}
                                    </div>
                                    {/* <img src={renameicon} alt="renameicon" /> */}
                                  </div>
                                  {openRightSection && (
                                    <div
                                      className="p-absolute cart_list"
                                      style={{
                                        position: 'absolute',
                                        left: '100%',
                                        padding: '16px',
                                        right: '100%',
                                      }}
                                    >
                                      <div className="color_heading">Folder Color</div>

                                      <div className="dis_grid grid_cols_5 gap-2">
                                        {selectionColors?.map((item) => (
                                          <div
                                            style={{
                                              backgroundColor: item?.hex,
                                              width: '32px',
                                              height: '32px',
                                              borderRadius: '50%',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                            }}
                                            onClick={() => {
                                              handleSaveColor(row, item);
                                            }}
                                          >
                                            {' '}
                                            {row?.color === item?.hex &&
                                              DAM_SVG.folderSelectTickIcon}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                              {hasDAMAccess(MODULE_IDS.DAM) && (
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();
                                    setSelectedDamFieldId(row?.id);
                                    handleshowdata(row?.id, 0);
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.permissionSvg}
                                  <p className="list_cart">Invite Outside Org.</p>
                                </div>
                              )}
                            </div>
                          )
                        }
                        HandleEllipseClick={() => {
                          const updatedValueAssets = selectedAssets?.map((item) => ({
                            ...item,
                            isSelected: false,
                          }));
                          dispatch(SelectedAssetData(updatedValueAssets));
                          const updatedValue = selectedFolders?.map((item) =>
                            item?.id === row?.id
                              ? { ...item, isSelected: true }
                              : { ...item, isSelected: false },
                          );

                          setAssets({
                            files: files?.map((item) => ({
                              ...item,
                              isSelected: false,
                            })),
                          });

                          dispatch(SetSelctedFoldersData(updatedValue));
                        }}
                        Top={'15px'}
                        Right={'170px'}
                      />
                    ) : (
                      <div>
                        {' '}
                        <CommonSidePortal
                          activeId={activeId}
                          setActiveId={setActiveId}
                          portalId={rowIndex}
                          ViewSection={<CommonThreeDotSvg />}
                          OpenSection={
                            trash ? (
                              <>
                                {' '}
                                {isSelf && hasDAMAccess(MODULE_IDS.DAM , [USER_RIGHTS.FullAccess]) && (
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActiveId();
                                      setSelectedDamFieldId(row.id);
                                      deletmodal(row?.folderName);
                                    }}
                                  >
                                    {' '}
                                    {DAM_SVG.redDeleteIconSvgComponent}
                                    <p className="list_cart">
                                      {trash ? 'Delete' : 'Move to trash'}
                                    </p>
                                  </div>
                                )}
                                {isSelf && hasDAMAccess(MODULE_IDS.DAM ,  [USER_RIGHTS.FullAccess]) && (
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={() => {
                                      // setSelectedDamFieldId(image.damFileId);
                                      handleRestoreAsset(row.id);
                                      setSelectedDamFieldId(row.id);
                                    }}
                                  >
                                    {/* <img src={deleteicon} alt="deleteicon" /> */}

                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-archive-restore-icon lucide-archive-restore"
                                    >
                                      <rect width="20" height="5" x="2" y="3" rx="1" />
                                      <path d="M4 8v11a2 2 0 0 0 2 2h2" />
                                      <path d="M20 8v11a2 2 0 0 1-2 2h-2" />
                                      <path d="m9 15 3-3 3 3" />
                                      <path d="M12 12v9" />
                                    </svg>
                                    <p className="list_cart">Restore</p>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="">
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={() => {
                                    setMovetoModal(true);
                                    setSelectedDamFieldId(row.assetId);
                                    setActiveId();
                                  }}
                                >
                                  {DAM_SVG.moveAssetSvgIcon}
                                  <p className="list_cart">Move Folder</p>
                                </div>
                                {isSelf && hasDAMAccess(MODULE_IDS.DAM ,  [USER_RIGHTS.FullAccess]) && (
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActiveId();
                                      setSelectedDamFieldId(row.id);
                                      deletmodal(row?.folderName);
                                    }}
                                  >
                                    {' '}
                                    {DAM_SVG.redDeleteIconSvgComponent}
                                    <p className="list_cart">
                                      {trash ? 'Delete' : 'Move to trash'}
                                    </p>
                                  </div>
                                )}
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();
                                    handledownload(row);
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.downloadIcons}
                                  <p className="list_cart">Download</p>
                                </div>
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();
                                    setSelectedDamFieldId(row?.id);
                                    setRenameDetails({
                                      isFolder: false,
                                      Data: row,
                                    });
                                    settextvalue(row?.assetName);
                                    setAddToCollectionModal(!AddToCollectionModal);
                                  }}
                                >
                                  {DAM_SVG.blackrenameIcon}
                                  <p className="list_cart">Rename</p>
                                </div>
                                {hasDAMAccess(MODULE_IDS.DAM , [USER_RIGHTS.FullAccess]) && (
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      dispatch(setOpenPopup(row));
                                      setActiveId();
                                    }}
                                  >
                                    {' '}
                                    {DAM_SVG.blackShareIconSvg}
                                    <p className="list_cart">Share</p>
                                  </div>
                                )}
                                {hasDAMAccess(MODULE_IDS.DAM) && (
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={() => {
                                      // collectiondataadd(image.damFileId);
                                      setSelectedDamFieldId(row?.id);
                                      setActiveId();
                                      setOpenCollectionModal(true);
                                    }}
                                  >
                                    <img src={addcomponent} alt="coomponenticon" />
                                    <p className="list_cart">Add to Collection</p>
                                  </div>
                                )}
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveId();
                                    setSelectedDamFieldId(row?.id);
                                    handleshowdata(row?.id, 0);
                                  }}
                                >
                                  {' '}
                                  {DAM_SVG.permissionSvg}
                                  <p className="list_cart">Invite Outside Org.</p>
                                </div>
                                {hasDAMAccess(MODULE_IDS.DAM) && (
                                  <div
                                    className="d-flex align-items-center gap-2 pointer"
                                    onClick={() => {
                                      setOpenEmmbedPopup(row);
                                      setActiveId(null);
                                    }}
                                  >
                                    {' '}
                                    {DAM_SVG.embedIcon}
                                    <p className="list_cart">Embed</p>
                                  </div>
                                )}
                              </div>
                            )
                          }
                          HandleEllipseClick={() => {
                            const updatedValueFolders = selectedFolders?.map((item) => ({
                              ...item,
                              isSelected: false,
                            }));
                            dispatch(SetSelctedFoldersData(updatedValueFolders));

                            const updatedValue = selectedAssets?.map((item) =>
                              item?.assetId === row?.assetId
                                ? { ...item, isSelected: true }
                                : { ...item, isSelected: false },
                            );

                            dispatch(SelectedAssetData(updatedValue));

                            setAssets({
                              files: files?.map((item) => ({
                                ...item,
                                isSelected: item?.assetId === row?.assetId ? true : false,
                              })),
                            });
                          }}
                          Top={'15px'}
                          Right={'170px'}
                        />
                      </div>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={headers.length} className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Modal isOpen={openEmmbedPopup} style={{ width: '50vh' }}>
        <ModalHeader
          toggle={() => {
            setOpenEmmbedPopup((pre) => (pre ? null : true));
          }}
        >
          {' '}
          Copy url to embed
        </ModalHeader>
        <ModalBody>
          <CopyField label="Original File URL" value={openEmmbedPopup?.ogUrl} />

          <CopyField label="Thumbnail URL" value={openEmmbedPopup?.thumnnailUrl} />

          {/* <CopyField label="View File URL" value={openEmmbedPopup?.vifUrl} /> */}
        </ModalBody>
      </Modal>

      {openCollectionModal && (
        <AddToCollectionCommonModal
          openModal={openCollectionModal}
          Data={selectedDamFieldId}
          ToggleModal={() => {
            setOpenCollectionModal(!openCollectionModal);
          }}
        />
      )}
    </Fragment>
  );
};

export default CommonTable;
